export function section07() {
    let animationComplete = false
    // second animation sequence
    let segment02 = gsap
        .timeline({
            onStart: () => {
                const cards = gsap.utils.toArray(".card-img")
                cards.forEach((card) => {
                    moveX(card, 1)
                    moveY(card, -1)
                })
            },
            onComplete: () => {
                animationComplete = true
            },
        })
        .from(
            ".section.slice-7 .card-space .card#main-card .image",
            {
                scale: 1.15,
                duration: 0.5,
                ease: "Power1.out",
            }
        )
        .from(
            ".section.slice-7 .card-space .card#main-card",
            {
                width: "100%",
                height: "100%",
                padding: 0,
                duration: 1,
                ease: "expo.out",
            },
            "<"
        )
        .from(
            ".section.slice-7 .card-space .card#main-card .content",
            {
                opacity: 0,
                y: 25,
                duration: 0.5,
                ease: "Power2.inOut",
            },
            ">-0.35"
        )
        .from(
            ".section.slice-7 .card-space .card#main-card .content .title",
            {
                y: 25,
                opacity: 0,
                duration: 1,
                ease: "expo.out",
            },
            "<+0.35"
        )
        .from(
            ".section.slice-7 .card-space .card#main-card .content .date",
            {
                height: 0,
                opacity: 0,
                y: 100,
                duration: 1,
                ease: "expo.out",
            },
            "<+0.25"
        )
    segment02.pause()

    //first animation sequence
    let segment01 = gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-7",
            // start: "bottom 95%",
            start: "bottom bottom",
            // scrub: true,
            // pin: ".section.slice-7",
            // once: true,
            // pinSpacing: true,
        },
        onComplete: function () {
            segment02.play()
        },
    })
        .to(".section.slice-7 .card-space .card#main-card .gradient", {
            opacity: 0,
            duration: 0.5,
            ease: "Power1.out",
        })
        .to(
            ".section.slice-7 .card-space .card#main-card .image .container",
            {
                opacity: 0,
                y: -55,
                duration: 0.5,
                ease: "Power1.out",
            },
            "<"
        )

    // floating animation
    const randomX = random(1, 10)
    const randomY = random(1, 10)
    const randomTime = random(3, 5)

    const cards = gsap.utils.toArray(".card-img")
    cards.forEach((card) => {
        gsap.set(card, {
            x: randomX(-1),
            y: randomX(1),
        })

        let maxSize = 20
        let minSize = 15
        let maxPos = 100
        let minPos = 0
        // let maxOpacity = 100;
        // let minOpacity = 65;
        let vertPosRange =
            Math.floor(Math.random() * (maxPos - minPos) + minPos) + "%"
        let horiPosRange =
            Math.floor(Math.random() * (maxPos - minPos) + minPos) + "%"
        let cardSize = Math.floor(Math.random() * (maxSize - minSize) + minSize)
        // let cardOpacity = Math.floor(Math.random() * (maxOpacity - minOpacity) + minOpacity);

        card.style.top = vertPosRange
        card.style.left = horiPosRange

        card.style.width = cardSize + "%"
        card.style.marginLeft = "-" + cardSize / 2 + "%"
        card.style.marginTop = "-" + cardSize / 2 + "%"
        // card.style.opacity = cardOpacity * 0.01;
    })

    function moveX(target, direction) {
        gsap.to(target, randomTime(), {
            x: randomX(direction),
            ease: Sine.easeInOut,
            onComplete: moveX,
            onCompleteParams: [target, direction * -1],
        })
    }

    function moveY(target, direction) {
        gsap.to(target, randomTime(), {
            y: randomY(direction),
            ease: Sine.easeInOut,
            onComplete: moveY,
            onCompleteParams: [target, direction * -1],
        })
    }

    function random(min, max) {
        const delta = max - min
        return (direction = 1) => (min + delta * Math.random()) * direction
    }

    

    // create intersection observer to pause video if not in view
    let observer = new IntersectionObserver(function (entries) {
        if (animationComplete === true) {
            if (!entries[0].isIntersecting) {
                segment01.pause()
                segment02.pause()
                segment01.progress(0)
                segment02.progress(0)
            } else {
                setTimeout(function() {
                    segment01.play()
                }, 500)
            }
        }
    });
    
    observer.observe(document.querySelector("section.slice-7"))
}